export const hospitalDrgColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'billed_drg_flag',
  'derived_drg_type',
  'derived_drg_version',
  'drg_code',
  'drg_name',
  'drg_type',
  'drg_version',
  'drg_weight',
  'fk_hospital__clinical_id',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'risk_of_mortality',
  'severity_of_illness',
  'snapshot_id',
];
